var _rect, _path, _circle, _circle2, _circle3, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H188C194.627 0 200 5.37258 200 12V26H0V12Z",
    fill: "#AAAAAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 4,
    fill: "#FF847C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 13,
    r: 4,
    fill: "#FAD17B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 13,
    r: 4,
    fill: "#97E17E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2905 65.4288C78.4224 67.4247 78.5327 70.771 76.5369 72.9029L60.5313 89.9998L76.5369 107.097C78.5327 109.229 78.4224 112.575 76.2905 114.571C74.1585 116.567 70.8123 116.456 68.8164 114.324L49.4276 93.6137C47.5241 91.5804 47.5241 88.4193 49.4276 86.386L68.8164 65.6752C70.8123 63.5433 74.1585 63.433 76.2905 65.4288Z",
    fill: "#547AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.823 65.4288C120.691 67.4247 120.58 70.771 122.576 72.9029L138.582 89.9998L122.576 107.097C120.58 109.229 120.691 112.575 122.823 114.571C124.955 116.567 128.301 116.456 130.297 114.324L149.685 93.6137C151.589 91.5804 151.589 88.4193 149.685 86.386L130.297 65.6752C128.301 63.5433 124.955 63.433 122.823 65.4288Z",
    fill: "#547AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.911 64.3868C112.618 65.4814 113.926 68.5635 112.832 71.2711L96.0867 112.693C94.9922 115.4 91.91 116.708 89.2024 115.613C86.4949 114.519 85.1873 111.436 86.2819 108.729L103.027 67.3074C104.121 64.5999 107.203 63.2923 109.911 64.3868Z",
    fill: "#547AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeb);
export default __webpack_public_path__ + "static/media/icon_web.8a838481530cf7b3e5ac4cce5700610f.svg";
export { ForwardRef as ReactComponent };